import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenericLoaderService } from './generic-loader.service';

@Component({
  selector: 'generic-loader',
  imports: [CommonModule],
  template: `
  <style>
@keyframes spin {
0% { transform: rotate(0deg); }
100% { transform: rotate(360deg); }
}
.loader-position {
position: fixed;
top: 50%;
left: 45%;
z-index: 9999;
}

.error-popup h4 {margin: 10px 0}
.error-popup p {font-size: 18px}

</style> 

<div *ngIf="spinSvc.showSpinner">
<div class="loaderDiv">
<div class="ajax-loader">     
</div>
</div>
</div>
`,
    styles: ``
})
export class GenericLoaderComponent {

  public spinSvc: GenericLoaderService = inject(GenericLoaderService);
  constructor(public spinnerService: GenericLoaderService) {
  }

  closePopUp() {
    this.spinnerService.isErrorOccured = false;
  }
}
